<template>
  <div id="device">
    <div class="title">日志管理</div>
    <div class="container">
      <div style="margin-bottom:20px">
        所属模块：
        <el-select
          v-model="value"
          placeholder="请选择"
          clearable
          @change="modelchange"
          style="margin-right:20px"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span class="texttype">操作时间：</span>
        <el-date-picker
          v-model="moment"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:260px;margin-right:20px"
          @change="timeChange"
          :picker-options="startPickerOptions"
          class="mr20"
        ></el-date-picker>
        <span class="texttype">所属场所：</span>
        <el-autocomplete
          class="inline-input"
          clearable
          v-model="unit"
          :fetch-suggestions="querySearch"
          placeholder="请输入所属场所"
          @select="handleSelect"
          @change="unitchange"
          style="width:220px"
        ></el-autocomplete>
      </div>
      <el-table :data="activelogdata" stripe>
        <!-- <el-table-column prop="unit" label="所属模块"></el-table-column> -->
        <el-table-column prop="module" label="所属模块"></el-table-column>
        <el-table-column prop="type" label="日志类型">
          <template slot-scope="scop">
            <div>{{operatetype[scop.row.type]}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="操作人"></el-table-column>
        <el-table-column prop="content" label="操作内容"></el-table-column>
        <el-table-column prop="operateTime" label="操作时间" align="right"></el-table-column>
      </el-table>
      <div class="paginationmain">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="activelogtotal"
          @current-change="operatesizechange"
          :current-page.sync="current"
          hide-on-single-page
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { logoperatelist } from "../axios/api.js";

export default {
  data() {
    return {
      activeName: this.devicelogshow ? "first" : "second",
      tableData: [],
      unitlist: [],
      unit: "",
      activelogdata: [],
      devicelogvisible: false,
      devicelogshow: false,
      operatelogshow: false,
      deviceid: "",
      devicecont: "",
      moment: "",
      totalpage: 0,
      pageNum: 1,
      current: 1,
      activelogtotal: 0,
      unitName: null,
      value: null,
      startPickerOptions: {
        disabledDate: time => {
          //小于最小时间或者大于最大时间都不可选
          return time.getTime() > new Date();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date().toLocaleDateString();
              // start.setTime(new Date());
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date().toLocaleDateString();
              const start = new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      options: [
        {
          value: "登录模块",
          label: "登录模块"
        },
        {
          value: "单位管理",
          label: "单位管理"
        },
        {
          value: "人员管理",
          label: "人员管理"
        },
        {
          value: "空气传感器管理",
          label: "空气传感器管理"
        },
        {
          value: "插座管理",
          label: "插座管理"
        },
        {
          value: "水表管理",
          label: "水表管理"
        },
        {
          value: "用户管理",
          label: "用户管理"
        },
        {
          value: "角色管理",
          label: "角色管理"
        }
      ],
      datatype: {
        1: "心跳数据",
        2: "数据上报",
        3: "上电数据",
        4: "下线数据"
      },
      operatetype: {
        1: "登录",
        2: "登出",
        3: "添加",
        4: "删除",
        5: "修改",
        6: "查询"
      },
      deviceType: {
        11: "建大仁科传感器",
        12: "空气道传感器",
        21: "灵源插座",
        22: "钛比插座",
        23: "灵源4G插座",
        31: "水表"
      }
    };
  },
  methods: {
    handleClick() {
      console.log(this.activeName);
    },

    timeChange(value) {
      if (value) {
        this.startTime = this.$moment(value[0]).format("yyyy-MM-DD 00:00:00");
        this.endTime = this.$moment(value[1]).format("yyyy-MM-DD 23:59:59");
        // this.queryParams.pageNum = 1
      } else {
        this.startTime = null;
        this.endTime = null;
        // this.queryParams.pageNum = 1
      }
      this.current = 1;
      this.getactivitylog();
      // console.log(value);
    },

    //模块选择
    modelchange(value) {
      console.log(value);
      if (!value) {
        this.value = null;
        this.current = 1;
        this.getactivitylog();
      } else {
        this.current = 1;
        this.getactivitylog();
      }
    },

    querySearch(queryString, cb) {
      for (var i in this.unitlist) {
        this.unitlist[i].value = this.unitlist[i].unit;
      }
      var unitlist = this.unitlist;
      console.log(unitlist);
      var results = queryString
        ? unitlist.filter(this.createFilter(queryString))
        : unitlist;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

    createFilter(queryString) {
      return unitlists => {
        return (
          unitlists.value.toLowerCase().indexOf(queryString.toLowerCase()) !==
          -1
        );
      };
    },

    //选择酒店
    handleSelect(item) {
      console.log(item);
      this.unitName = item.unit ? item.unit : null;
      this.getactivitylog();
    },

    unitchange(value) {
      console.log(value);
      if (!value) {
        this.current = 1;
        this.unitName = null;
        this.getactivitylog();
      }
    },

    //所有日志
    reset() {
      this.deviceid = "";
      this.pageNum = 1;
    },

    //获取操作日志
    getactivitylog() {
      const params = {
        current: 1,
        size: 10,
        type: this.type,
        startTime: this.startTime,
        endTime: this.endTime,
        platforms: 7,
        module: this.value,
        unitName: this.unitName
      };
      logoperatelist(params).then(res => {
        console.log(res.data);
        this.activelogdata = res.data;
        this.activelogtotal = res.total;
      });
    },
    //分页
    operatesizechange(e) {
      this.current = e;
      const params = {
        current: e,
        size: 10,
        type: this.type,
        startTime: this.startTime,
        endTime: this.endTime,
        platforms: 7,
        module: this.value,
        unitName: this.unitName
      };
      logoperatelist(params).then(res => {
        console.log(res.data);
        this.activelogdata = res.data;
        this.activelogtotal = res.total;
      });
    },

    powerlist() {
      var arr = JSON.parse(localStorage.getItem("menus"));
      console.log(arr);
      for (var i in arr) {
        if (arr[i].menuId === 2054) {
          this.devicelogshow = true;
        }
        if (arr[i].menuId === 2056) {
          this.operatelogshow = true;
        }
      }
    }
  },

  created() {
    // 加载表格数据
    this.getactivitylog();
  }
};
</script>
<style scoped>
.paginationmain {
  margin-top: 10px;
  text-align: right;
}

.mr20 {
  width: 400px;
  margin-right: 10px;
  margin-left: 5px;
}

#device .el-tabs__nav-scroll {
  background: #fff;
  padding-left: 25px;
  height: 55px;
}

#device .el-tabs__item {
  height: 55px;
  line-height: 55px;
}

#device .tabcont {
  background: white;
  padding: 20px;
}

.searchinput {
  width: 300px;
  text-align: left;
  margin-bottom: 20px;
}
</style>